import { render, staticRenderFns } from "./TripsList.vue?vue&type=template&id=641a31e4&scoped=true"
import script from "./TripsList.vue?vue&type=script&lang=js"
export * from "./TripsList.vue?vue&type=script&lang=js"
import style0 from "./TripsList.vue?vue&type=style&index=0&id=641a31e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641a31e4",
  null
  
)

export default component.exports